var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-color-picker", {
    staticClass: "mx-auto colourPicker",
    attrs: {
      "hide-mode-switch": "",
      "hide-inputs": "",
      mode: "rgba",
      "canvas-height": "100",
      width: "300",
      value: _vm.rgbColour,
    },
    on: { "update:color": _vm.updated },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }